/* Basic Musthaves — PDP kleur-picker (V11-VARIANTMODEL)
   Variant-model: MAAT = native varianten van dit product (afgehandeld door de
   native-optie-JS in mts-main-product.liquid). KLEUR = zusterproducten: elke
   kleur is een eigen product met dezelfde groep-tag (groep-<item_group_id>).
   Deze picker haalt de siblings op, bouwt 1 swatch per kleur en navigeert bij
   klik naar dat kleur-product. */
(function () {
  var vp = document.querySelector('[data-mts-vp]');
  if (!vp) return;

  var group = vp.getAttribute('data-mts-group');
  var curColor = (vp.getAttribute('data-mts-color') || '').toLowerCase();
  var elBlock = vp.querySelector('[data-mts-vp-block="color"]');
  var elSwatches = vp.querySelector('[data-mts-vp-swatches]');
  var elLabel = vp.querySelector('[data-mts-vp-color-label]');
  if (!group || !elSwatches) return;

  function tagVal(tags, prefix) {
    for (var i = 0; i < tags.length; i++) {
      var t = String(tags[i]).toLowerCase();
      if (t.indexOf(prefix) === 0) return t.slice(prefix.length);
    }
    return '';
  }

  function colorHex(slug) {
    var s = slug.toLowerCase();
    if (s.indexOf('white') >= 0 || s.indexOf('wit') >= 0) return '#f4f1ea';
    if (s.indexOf('black') >= 0 || s.indexOf('zwart') >= 0) return '#161311';
    if (s.indexOf('anthracite') >= 0 || s.indexOf('antraciet') >= 0) return '#39352f';
    if (s.indexOf('dark-grey') >= 0 || s.indexOf('dark-gray') >= 0) return '#565049';
    if (s.indexOf('grey') >= 0 || s.indexOf('gray') >= 0 || s.indexOf('grijs') >= 0) return '#8d8578';
    if (s.indexOf('navy') >= 0 || s.indexOf('dark-blue') >= 0 || s.indexOf('marine') >= 0) return '#25314c';
    if (s.indexOf('blue') >= 0 || s.indexOf('blauw') >= 0) return '#3b6ea5';
    if (s.indexOf('skin') >= 0 || s.indexOf('nude') >= 0) return '#e3c3a3';
    if (s.indexOf('daino') >= 0 || s.indexOf('taupe') >= 0 || s.indexOf('camel') >= 0) return '#b39068';
    if (s.indexOf('brown') >= 0 || s.indexOf('bruin') >= 0) return '#7d6f5e';
    if (s.indexOf('beige') >= 0 || s.indexOf('zand') >= 0) return '#d9c8a8';
    if (s.indexOf('khaki') >= 0 || s.indexOf('olive') >= 0 || s.indexOf('olijf') >= 0 || s.indexOf('leger') >= 0) return '#7c7b53';
    if (s.indexOf('green') >= 0 || s.indexOf('groen') >= 0) return '#3f7a44';
    if (s.indexOf('red') >= 0 || s.indexOf('rood') >= 0) return '#c0392b';
    if (s.indexOf('cognac') >= 0) return '#9a5b34';
    if (s.indexOf('orange') >= 0 || s.indexOf('oranje') >= 0 || s.indexOf('coral') >= 0 || s.indexOf('koraal') >= 0) return '#d47b32';
    if (s.indexOf('gold') >= 0 || s.indexOf('goud') >= 0) return '#c9a227';
    if (s.indexOf('yellow') >= 0 || s.indexOf('geel') >= 0 || s.indexOf('oker') >= 0) return '#e8b93a';
    if (s.indexOf('purple') >= 0 || s.indexOf('paars') >= 0 || s.indexOf('lila') >= 0) return '#7d5ba6';
    if (s.indexOf('silver') >= 0 || s.indexOf('zilver') >= 0) return '#c4c4c4';
    if (s.indexOf('pink') >= 0 || s.indexOf('roze') >= 0) return '#eaa0bb';
    return '#cfc6b3';
  }

  // Kleur-slug (uit Engelse color_name) → NL weergave. Echt-Engelse woorden
  // vertaald; leenwoorden (navy, nude, beige, cognac, daino, khaki) behouden.
  // Houd in sync met scripts/lib/color-word-nl.mjs (titel-normalisatie).
  var COLOR_FULL = {
    'anthracite-melange': 'Antraciet gemêleerd', 'black-melange': 'Zwart gemêleerd',
    'grey-melange': 'Grijs gemêleerd', 'beige-melange': 'Beige gemêleerd',
    'pink-melange': 'Roze gemêleerd', 'red-melange': 'Rood gemêleerd',
    'purple-melange': 'Paars gemêleerd', 'dark-blue-melange': 'Donkerblauw gemêleerd',
    'dark-grey': 'Donkergrijs', 'dark-blue': 'Donkerblauw', 'norwegian-grey': 'Noors grijs',
    'kobalt-blue': 'Kobaltblauw', 'marine-marine-blue': 'Navy', 'm-grey': 'Gemêleerd grijs',
    'm-black': 'Gemêleerd zwart', 'skin-nude': 'Nude', 'khaki': 'Khaki', 'daino': 'Daino'
  };
  var COLOR_WORD = {
    black: 'Zwart', white: 'Wit', grey: 'Grijs', gray: 'Grijs', green: 'Groen',
    red: 'Rood', pink: 'Roze', purple: 'Paars', yellow: 'Geel', brown: 'Bruin',
    blue: 'Blauw', orange: 'Oranje', silver: 'Zilver', gold: 'Goud', coral: 'Koraal',
    skin: 'Huidskleur', anthracite: 'Antraciet', melange: 'gemêleerd', multi: 'Multi',
    dark: 'Donker', norwegian: 'Noors'
  };
  function prettyColor(slug) {
    var full = COLOR_FULL[slug];
    if (full) return full;
    return slug.split('-').map(function (w) {
      if (!w) return w;
      var nl = COLOR_WORD[w.toLowerCase()];
      if (nl) return nl;
      return w.charAt(0).toUpperCase() + w.slice(1);
    }).join(' ');
  }

  function build(items) {
    var seen = {}, colors = [];
    items.forEach(function (it) {
      var c = tagVal(it.tags, 'kleur-');
      if (!c || seen[c]) return;
      seen[c] = it; colors.push(c);
    });
    if (elLabel && curColor) elLabel.textContent = prettyColor(curColor);
    if (colors.length < 2) return; // maar 1 kleur → geen swatch-keuze

    elSwatches.innerHTML = '';
    colors.forEach(function (c) {
      var it = seen[c];
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mts-swatch-btn' + (c === curColor ? ' is-active' : '');
      b.style.background = colorHex(c);
      b.title = prettyColor(c);
      b.setAttribute('aria-label', prettyColor(c));
      b.addEventListener('click', function () {
        if (c === curColor || !it.url) return;
        window.location.href = it.url;
      });
      elSwatches.appendChild(b);
    });
    elBlock.hidden = false;
  }

  var url = '/search?type=product&view=siblings&q=' + encodeURIComponent('tag:' + group);
  fetch(url, { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.text(); })
    .then(function (txt) {
      var items;
      try { items = JSON.parse(txt); } catch (e) { return; }
      if (!Array.isArray(items)) return;
      build(items);
    })
    .catch(function () { /* stil: product blijft koopbaar via native varianten */ });
})();
